import axios from "axios";
import { REACT_APP_API } from "../constants";
import { checkAPISuccess, manageServiceError } from "../utils/helpers";
import { requestsFor } from "./headerService";

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API}`,
});

export const appAxios = axiosInstance

const path = {
  login: "/authentication/okta/normalLogin",
  oktaLogout: "/okta/Logout",
  clientLogout: "/v1/Logout",
  policyList: "/api/v1/policyService/ListPolicy",
  connectionMode: "/api/v1/secretservice/getConnectionMode",
  discoverADPolicies: "/api/v1/policyService/DiscoverADPolicies",
  applyDiscoveredPolicies: "/api/v1/policyService/ApplyDiscoveredPolicies",
  deletePolicyJSON: "/api/v1/policyService/deletePolicyJSON",
  previewImpact: "/api/v1/policyService/PreviewImpact",
  getAllDomains: "/ad/GetAllDomains",
  getUnenrolledUsersInGroup: "/ad/GetUnenrolledUsersInGroup",
  sendEnrollmentEmail: "/ad/SendEnrollmentEmail",
};

const requests = requestsFor(axiosInstance);

export async function authendicateUser({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.login, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Login Failed");
  }
}

export async function oktaLogout({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.oktaLogout, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Okta Logout Failed");
  }
}

export async function clientLogout({ payload, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.clientLogout, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Client Logout Failed");
  }
}

export async function getUserDetails({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post("/authnz/getUserDetails", payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Get User Details Failed");
  }
}


export async function getPolicyList({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.policyList, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Get Policy List Failed");
  }
}

export async function getConnectionMode({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.connectionMode, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Get Connection Mode Failed");
  }
}

export async function getAllDomains({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.getAllDomains, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Get All Domains Failed");
  }
}

export async function discoverADPolicies({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.discoverADPolicies, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Discover AD Policies Failed");
  }
}

export async function applyDiscoveredPolicies({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.applyDiscoveredPolicies, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Apply Discovered Policies Failed");
  }
}

export async function deletePolicyJSON({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.deletePolicyJSON, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Delete Policy Failed");
  }
}

export async function getUnenrolledUsersInGroup({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.getUnenrolledUsersInGroup, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Get Unenrolled Users Failed");
  }
}

export async function sendEnrollmentEmail({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.sendEnrollmentEmail, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Send Enrollment Email Failed");
  }
}

export async function previewImpact({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.previewImpact, payload);
    onSuccess && onSuccess(response);
  } catch (error) {
    manageServiceError(error, onFailure, "Preview Impact Failed");
  }
}